// extracted by mini-css-extract-plugin
export default {"PackageDetails":"PackageDetails_PackageDetails__mSfQi","descriptionWrapper":"PackageDetails_descriptionWrapper__vOFR6"};